export class TenantMsGraphOptions {
  id?: string;
  tenantId: string = '';
  title: string = '';
  msGraphTenantId: string = '';
  msGraphClientId: string = '';
  msGraphClientSecret: string = '';
  msGraphSenderId: string = '';
  msGraphFromMail: string = '';
  useForSystemMails: boolean = false;
  customBusinessCard: boolean = false;
  customBusinessCardContent: string = '';
  useSharePointForDataRoom: boolean = false;
  startFolderPath: string = '';
  startFolderId: string = '';
  startFolderName: string = '';
  driveId: string = '';
}
